// Plain pub/sub mirror of the coreSeqJobs realtime push, kept outside Redux so
// that non-React modules (nodeAxiosFirebase.js) can read the latest job
// snapshot without importing the store module graph — nodeAxiosFirebase.js is
// itself imported by several slices (elementSlice.js, listSlice.js), so
// importing the Redux store from here would create a circular dependency.
// useRealtimeSocket.js feeds this cache alongside dispatch(setCoreSeqJobs(...)).

let jobsById = new Map();
const listeners = new Set();

export function updateCoreSeqJobsCache(jobs) {
  jobsById = new Map((jobs || []).map((job) => [job.id, job]));
  listeners.forEach((callback) => callback());
}

export function getCachedCoreSeqJob(jobId) {
  return jobsById.get(jobId) || null;
}

export function subscribeCoreSeqJobs(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
